import { EventFeedItem } from 'app/shared/components/feed/feed.model';
import { TripTimelineItem } from 'app/shared/rad/trip-timeline/trip-timeline.component';
import { PreviewTarget, PreviewView } from './preview.model';

export const PREVIEW_VIEWS = {
    status: {
        title: 'SHARED.PREVIEW.TITLES.STATUS',
        params: ['assetId'],
        loadComponent: () => import('./panels/status-preview.component').then(m => m.KeyRadStatusPreviewComponent),
        buildTarget: (assetId: string): PreviewTarget => ({ kind: 'status', params: { assetId } }),
    },
    trip: {
        title: 'SHARED.PREVIEW.TITLES.TRIP',
        params: ['assetId', 'start', 'end'],
        loadComponent: () => import('./panels/trip-preview.component').then(m => m.KeyRadTripPreviewComponent),
        buildTarget: (assetId: string, trip: TripTimelineItem): PreviewTarget => (
            { kind: 'trip', params: { assetId, start: trip.dateStart, end: trip.inProgress ? '' : trip.dateEnd } }
        ),
    },
    event: {
        title: 'SHARED.PREVIEW.TITLES.EVENT',
        params: ['assetId', 'eventId', 'date'],
        loadComponent: () => import('./panels/event-preview.component').then(m => m.KeyRadEventPreviewComponent),
        buildTarget: (assetId: string, event: EventFeedItem): PreviewTarget => (
            { kind: 'event', params: { assetId, eventId: event.id, date: event.date } }
        ),
    },
} satisfies Record<string, PreviewView>;
